import React, { useContext } from "react";
import "./style.scss";
import topSketch from "../../assets/images/footer-bottom-texturev2.png";
import { AuthContext } from "../../context";
import { BsFacebook, BsLinkedin } from "react-icons/bs";
import {
  AiOutlineTwitter,
  AiFillYoutube,
  AiFillGooglePlusSquare,
} from "react-icons/ai";
import { FaSquareInstagram } from "react-icons/fa6";
import { BsFillTelephoneFill } from "react-icons/bs";
import { HiOutlineMail } from "react-icons/hi";

const Index = () => {
  const { setCursor } = useContext(AuthContext);

  const mouseHover = () => setCursor("fill");
  const mouseOut = () => setCursor("");

  const social = [
    {
      Icon: BsFacebook,
      link: "https://www.facebook.com/share/1XZ4d77eN4/",
    },
    {
      Icon: AiOutlineTwitter,
      link: "https://x.com/N14231Nerd",
    },
    {
      Icon: FaSquareInstagram,
      link: "https://www.instagram.com/nerdnexus50/",
    },
    {
      Icon: BsLinkedin,
      link: "https://www.linkedin.com/company/nerd-nexus/?viewAsMember=true",
    },
  ];

  const services = [
    {
      name: "Web Design",
      link: "/services/webdesign",
    },
    {
      name: "Web Development",
      link: "/services/webdevelopment",
    },
    {
      name: "Brand Marketing",
      link: "/services/designbranding ",
    }
  ];

  return (
    <div className="footer__main">
      <div className="footer__sub__section container">
        <div className="row m-0 p-0">
          <div className="col-md-4 m-0 p-0 logo__section">
            <img src="/logo512.png" alt="logo" style={{ maxWidth: 200 }} />
          </div>
          <div className="row col-md-8 m-0 p-0">
            <div className="col-md-6 list__section">
              <h3>Services</h3>
              {services.map((v, i) => {
                return (
                  <a key={i} href={v?.link} className="list__item">
                    <div onMouseOver={mouseHover} onMouseOut={mouseOut}>
                      {v?.name}
                    </div>
                  </a>
                );
              })}
            </div>
            <div className="col-md-6 social__section">
              <h3>Contact</h3>
              <div>
                <div
                  onMouseOver={mouseHover}
                  onMouseOut={mouseOut}
                  className="d-flex mt-2 gap-2 align-items-center"
                >
                  <div></div>
                  
                </div>
                <div
                  onMouseOver={mouseHover}
                  onMouseOut={mouseOut}
                  className="d-flex mt-2 gap-2 align-items-center"
                >
                  <div></div>
                  <div>
                    <a href="tel:+92 321 2795724" className="list__item">
                      <BsFillTelephoneFill />
                      &nbsp;&nbsp; +92 321 2795724
                    </a>
                  </div>
                </div>
                <div
                  onMouseOver={mouseHover}
                  onMouseOut={mouseOut}
                  className="d-flex mt-2 gap-2 align-items-center"
                >
                  <div></div>
                  <div>
                    <a className="list__item" href="mailto:nerdnexus50">
                      <HiOutlineMail />
                      &nbsp;&nbsp; nerdnexus50@gmail.com
                    </a>
                  </div>
                </div>
             
              </div>
              <div className="d-flex justify-content-center align-items-center gap-2 icons__section">
                {social?.map(({ Icon, link }, i) => {
                  return (
                    <a href={link} target="_blank" rel="noreferrer" key={i}>
                      <Icon
                        className="social__icon"
                        color={"var(--pink)"}
                        size={24}
                      />
                    </a>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="texture__section">
        <img src={topSketch} alt="topSketch" />
      </div>
      <div className="copy__right__section">
        <h3>
          "We recognize the traditional stewards of the places where we live,
          study, and work"
        </h3>
        <p>© Nerd Nexus - ALL RIGHTS RESERVED</p>
      </div>
    </div>
  );
};

export default Index;
